import React from 'react';
import Spinner from './icons/spinner';

const Loading = ({
	className,
	style,
	spinnerClassName,
	spinnerStyle,
}) => (
	<div
		className={`d-flex justify-content-center w-100 align-items-center color-primary ${className}`}
		style={{ height: '50vh ', ...style }}
	>
		<Spinner style={{ width: '3em', ...spinnerStyle }} className={spinnerClassName} />
	</div>
);

export default Loading;
